import Dropdown from 'antd/lib/dropdown'
import 'antd/lib/dropdown/style/index.less'

export default Dropdown
